<template>
<div class="my-swiper" :class="{'empty': !imgArr.length > 0}"> 
  <swiper :options="swiperOption" ref="mySwiper">
    <swiper-slide v-for="(item, index) in imgArr"  :key="'swiper' + index">
      <!-- <span>{{index+1}} / {{imgArr.length}}</span> -->
      <img :src="item">
    </swiper-slide>
    <!-- <div class="my-pagination" slot="pagination"></div> -->
  </swiper>
</div>
</template>

<script>
export default {
  name: "swiper-common",
  props: ["imgArr"],
  data() {
    return {
      swiperOption: {
        autoplay: true,
        loop: true,
        grabCursor: true,
        // pagination: {
        //   el: ".my-pagination",
        // }
      },
    };
  }, 
  mounted() {
    // this._initSwiper(); 
  },
  created() {
    // setTimeout(() => {
    //   console.log(this.imgArr);
    // }, 400);
  },
  methods: {
  }
};
</script>

<style scoped lang='scss'> 
.my-swiper{
  // min-height: 300px;
  background-color: #f6f5f6;
  position: relative;
  &.empty {
    min-height: 0;
  }
  span{
    position: absolute;
    z-index: 10;
    right: 12px;
    bottom: 10px;
    display: block;
    font-size: 18px;
    color:#999;
  }
}
.swiper-container {
  width: 100%;
  height: 100%;
  .swiper-slide,
  .swiper-wrapper {
    height: auto !important;
  }
  .swiper-slide {
    text-align: center;
    font-size: 0;
    background: #fff;
      width: 100%;
    a,
    img {
      width: 100%;
    }
  }
}
</style>